import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators }  from 'redux';

import UploadIcon from './UploadIcon';

import merge from 'lodash/merge';

import { uploadObject } from "api/actions";

import {
  FILE_UPLOAD,
  FILE_UPLOADING,
  FILE_UPLOADING_PROGRESS,
  FILE_UPLOADING_SUCCESS,
  FILE_UPLOADING_CANCELLED,
  FILE_UPLOADING_FAILURE
} from 'constants/ActionTypes';

import Summary from "./Summary";
import FullDownload from "./FullDownload";

import {
  FILES_LENTH_WARN,
  MAX_CONCURRENT_UPLOADS,
  MAX_FILES_TO_DISPLAY,
  PAGE_LIMIT,
  STATUS,
  UPLOADING_STATUS_TEXT,
  UPLOAD_DONE_STATUS_TEXT
} from './constants';


class FileUploader extends React.Component {
  state = {
    files: {},
    full: false,
    uploading: false,
    show: false,
    status: STATUS.SILENT,
    page: 1,
  };

  async componentWillReceiveProps(props) {
    switch (props.type) {
      case FILE_UPLOAD:
        this.performUpload(props.files, props.prefix);
        break;
      case FILE_UPLOADING:;
        await this.updateFile(props.fileId, {
          cancelUploadSource: props.cancelUploadSource
        });
        break;
      case FILE_UPLOADING_CANCELLED:
        await this.updateFile(props.fileId, {
          cancelled: true,
          failed: false,
          uploading: false,
          uploaded: false
        });
        await this.uploadNextFilesInState();
        break;
      case FILE_UPLOADING_PROGRESS:
        await this.updateFile(props.fileId, {
          progress: props.fileProgress,
          failed: false,
          uploading: true,
          uploaded: false,
        });
        break;
      case FILE_UPLOADING_SUCCESS:
        await this.updateFile(props.fileId, {
          cancelled: false,
          failed: false,
          uploading: false,
          uploaded: true
        });

        await this.uploadNextFilesInState();
        break;
      case FILE_UPLOADING_FAILURE:
        await this.updateFile(props.fileId, {
          cancelled: false,
          failed: true,
          uploading: false,
          uploaded: true
        });

        if (props.fileDuplicate) {
          this.props.addNotification({
            message: `${props.fileName} was not uploaded because it's a duplicate, click overwrite to overwrite it.`,
            level: 'warning',
            autoDismiss: 0,
            uid: props.fileId,
            action: {
              label: 'overwrite',
              callback: async () => {
                await this.updateFile(props.fileId, {
                  cancelled: false,
                  overwrite: true,
                  failed: false,
                  uploading: false,
                  uploaded: false
                });

                await this.uploadNextFilesInState();
              }
            }
          });
        } else {
          this.props.addNotification({
            message: `${props.fileName} was not uploaded.`,
            level: 'error',
          });
        }

        await this.uploadNextFilesInState();

        break;
    }
  }



  clearDownloaded = () => {
    const { files } = this.state;

    const proxyFiles = Object.assign({}, files);

    const uploadedFiles = this.getUploadedFiles();

    const idsToRemove = uploadedFiles.map(file => file.id)


    idsToRemove.map(id => {
      delete proxyFiles[id];
      return this.props.removeNotification(id)
    });

    this.setState({
      files: proxyFiles
    })
  };


  hasFiles = () => {
    const files = this.state.files;
    for (let id in files) {
      if(files.hasOwnProperty(id)) {
        return true;
      }
    }

    return false;
  };

  onCancel = () => {
    this.setState({ show: false });
  }

  onShow = () => {
    this.setState({ show: true });
  }

  setSummaryStatus = (status) => {
    if (this.summary) this.summary.setStatus(status);
  };

  /**
   * This function toggles the view showing the upload status
   */
  toggleView = () => this.setState({ full: !this.state.full });


  


  /**
   * This function checks if there is any file still uploading
   */
  anyUploading = () => {
    const files = Object.values(this.state.files);
    
    files.forEach(file => {
      if (file.uploading) {
        return true;
      }
    })

    return false;
  };

    /**
   * This function checks if there is any file still pending
   */
  anyPending = () => {
    const files = Object.values(this.state.files);
    
    files.forEach(file => {
      if (!file.uploading && 
        !file.cancelled && 
        !file.failed &&
        !file.uploaded) {
        return true;
      }
    })

    return false;
  };

  /**
   * This function is called when there are no more files been uploaded
   */
  _endUpload() {
    this.setSummaryStatus(UPLOAD_DONE_STATUS_TEXT);

    this.setState({
      status: STATUS.SILENT
    })
  }

 /**
   * 
   * @param {Number} count This is the number of pending files to be gotten
   * 
   * This function returns a specified number of pending files. The number
   * defaults to the MAX_CONCURRENT_UPLOADS number if no number is given.
   */
  getPendingFiles(count = MAX_CONCURRENT_UPLOADS) {
    const keys = Object.keys(this.state.files);

    const files = [];

    let _count = count;

    for (let i = 0; i < keys.length && _count > 0; i++) {
      const key = keys[i];
      const file = this.state.files[key];

      if (!file.uploading && !file.cancelled && !file.failed && !file.uploaded){
        files.push(file);
        _count--;
      }
    }

    return files;
  }
 
  /**
   * 
   * @param {Number} count This is the number of uploading files to be gotten
   * 
   * This function returns a specified number of uploading files. The number
   * defaults to the MAX_CONCURRENT_UPLOADS number if no number is given.
   */
  getUploadedFiles() {
    const keys = Object.keys(this.state.files);

    const files = [];

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const file = this.state.files[key];

      if (file.uploaded){
        files.push(file);
      }
    }

    return files;
  }

  /**
   * 
   * @param {Number} count This is the number of uploading files to be gotten
   * 
   * This function returns a specified number of uploading files. The number
   * defaults to the MAX_CONCURRENT_UPLOADS number if no number is given.
   */
  getUploadingFiles(count = MAX_CONCURRENT_UPLOADS) {
    const keys = Object.keys(this.state.files);

    const files = [];

    for (let i = 0; i < keys.length && i < count; i++) {
      const key = keys[i];
      const file = this.state.files[key];

      if (file.uploading){
        files.push(file);
      }
    }

    return files;
  }

  /**
   * 
   * @param {Object} files Files to be appended
   * 
   * This function merges the current files in the state with
   * the new files
   */
  mergeFilesToStateFiles(files = {}) {
    return new Promise(resolve => {
      this.setState({
        files: merge(this.state.files, files)
      }, resolve)
    })
  }

  /**
   * 
   * @param {Array} files These are the files that are to be uploaded
   */
  performUpload(files = [], prefix) {
    const filesLength = files.length;
    let _files = [];

    if (filesLength > FILES_LENTH_WARN) {
      if (window.confirm(`Are you sure you want to upload ${filesLength} files?`)) {
        _files = this.prepareFiles(files, prefix)
      }
    } else {
      _files = this.prepareFiles(files, prefix)
    }

    if (Object.keys(_files).length > 0) {
      this._startUpload(_files)
    }
  }

  /**
   * 
   * @param {Array} files These are the files to be prepared
   * @returns {Object} The prepared files
   * 
   * The function takes in an array of files, and creates and object
   * for each file with extra properties to help tracking.
   * 
   */
  prepareFiles(files = [], prefix) {
    const _files = files
    .map((file, index) => {
      const id = `${Date.now()}_${index}_${file.name}`
      return { 
        [id]: {
          cancelled: false,
          failed: false,
          file,
          id,
          isPending(){
            return !this.uploading && 
            !this.cancelled && 
            !this.failed &&
            !this.uploaded
          },
          prefix,
          progress: 0,
          uploaded: false,
          uploading: false,
        }
      }
    });

    return Object.assign({}, ..._files);
  }

  /**
   * 
   * @param {Object} preparedFiles These are the prepared files to be uploaded
   * 
   * This function is called when new files are to be uploaded. It can also be called
   * when there are already files been uploaded. In the case where there are already files
   * been uploaded, it does nothing but add the new files to the state. If there are no files
   * been uploaded it sets the status in the state.
   */
  async _startUpload(preparedFiles = {}) {
    const { status } = this.state;

    await this.mergeFilesToStateFiles(preparedFiles)

    if (status === STATUS.SILENT) {
      this.setState({
        show: true,
        status: STATUS.UPLOADING
      }, this._uploadStarted)

      this.uploadNextFilesInState()
    }
  }

  /**
   * 
   * @param {String} fileId 
   * @param {Object} update 
   * 
   * This function takes in the id of a file in the state and updates the values of the file
   * with the provided values
   */
  updateFile(fileId, update = {}) {
    return new Promise(resolve => {
      const files = this.state.files;
      const file = files[fileId];

      this.setState({
        files: merge(files, { [file.id]: merge(file, update) })
      }, resolve)
    })
  }

  /**
   * 
   * @param {String} id The id of the file in state to be uploaded
   * 
   * This function takes in an id of a file in state and uploads the
   * file that the id belongs to
   */
  async uploadFile(id) {
    const file = this.state.files[id];

    if (file) {
      this.props.uploadObject(file);
      file.uploading = true;
      await this.mergeFilesToStateFiles({ [id]: file })
    }
  }

  /**
   * This function is called when a fresh set of uploads start.
   */
  _uploadStarted() {
    this.setSummaryStatus(UPLOADING_STATUS_TEXT)
  }

  /**
   * This function determines if the files the component
   * should perform an upload. It checks the files in state
   * and compares the number of files currently uploading with
   * the MAX_CONCURRENT_UPLOADS constant
   */
  shouldUpload() {
    const files = Object.values(this.state.files);

    let count = 0;

    files.forEach(file => {
      if (file.uploading){
        count++;
      }

      if(count >= MAX_CONCURRENT_UPLOADS){
        return false;
      }
    })

    return true
  }

  /**
   * This function finds the number of files that can be uploaded and
   * uploads them.
   */
  uploadNextFilesInState = async () => {
    const filesUploading = this.getUploadingFiles()

    const currentUploadingCount = filesUploading.length;

    if (currentUploadingCount < MAX_CONCURRENT_UPLOADS) {
      const filesToUpload = this.getPendingFiles()

      const allowedUploadNum = MAX_CONCURRENT_UPLOADS - currentUploadingCount;

      for (let i = 0; i < allowedUploadNum && i < filesToUpload.length; i++) {
        const toUpload = filesToUpload.pop();

        if (toUpload) {
          await this.uploadFile(toUpload.id)
        }
      }
    }

    if (!this.anyUploading() && !this.anyPending()) {
      this._endUpload();
    }
  }

  renderUploadIcon() {
    return (
      <UploadIcon onClick={this.onShow}/>
    )
  }



  render() {
    const { show, files = {} } = this.state;

    const hasFiles = this.hasFiles(files);

    if (show) {
      if (!hasFiles)
        return null;

      if (!this.state.full) {
        return (
          <Summary
            ref={ref => this.summary = ref}
            files={files}
            toggleView={this.toggleView}
            onCancel={this.onCancel}
            onClearDownloaded={this.clearDownloaded}
          />
        )
      } else {
        return (
          <FullDownload
            files={files}
            toggleView={this.toggleView}
            onClearDownloaded={this.clearDownloaded}
          />
        );
      }
    } else {
      if (hasFiles) {
        return this.renderUploadIcon()
      } else {
        return null;
      }
    }
  }
};

FileUploader.defaultProps = {
  files: []
};

FileUploader.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ uploadObject }, dispatch)
};

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage,
  type: state.type,
  cancelUploadSource: state.cancelUploadSource,
  files: state.files,
  fileProgress: state.fileProgress,
  fileId: state.fileId,
  fileIndex: state.fileIndex,
  fileName: state.fileName,
  fileDuplicate: state.fileDuplicate,
  prefix: state.prefix
});

export default connect(mapStateToProps, dispatchToProps)(
  FileUploader
);
